export default __webpack_public_path__ + "static/media/maxx.26abc675.png";